module.exports = __webpack_public_path__ + "img/IMG_2597.3feb43b5.jpg";